import { ProductDetailViewEvent } from '@/usecases/event-bus-for-third-party/event'

/**
 * @see https://my-color.esa.io/posts/1256
 */
export function handleProductDetailViewEvent(event: ProductDetailViewEvent): void {
  window.dataLayer.push({
    event: 'smb_item_detail_view',
    products: event.sku.map(sku => ({
      sku_number: sku.sku_number,
      price: sku.price,
    })),
  })
}
